export default __webpack_public_path__ + "2224113c32f416015c7572b00ca6dfea.jpg";